import { MediaManagerTemplate } from 'modules/core/domain/interfaces/supabase/media-manager/entity';
import mediaManagerRepository from 'modules/manager/domain/repositories/media-manager-repository';
import { useCallback, useState } from 'react';
import Modal from 'ud-ui/components/modal';

interface Args {
  onDeleted: () => void;
}

function useDeleteTemplateModal({ onDeleted }: Args) {
  const [template, setTemplate] = useState<MediaManagerTemplate | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const open = useCallback((next: MediaManagerTemplate) => {
    setTemplate(next);
    setIsOpen(true);
  }, []);
  const close = useCallback(() => setIsOpen(false), []);

  const onSubmit = useCallback(async () => {
    if (!template) return;
    setIsLoading(true);
    try {
      await mediaManagerRepository.deleteTemplate(template.id);
      onDeleted();
      close();
    } catch (error) {
      console.error('Failed to delete media manager template:', error);
    } finally {
      setIsLoading(false);
    }
  }, [template, onDeleted, close]);

  return {
    open,
    close,
    modal: (
      <Modal.Confirm
        show={isOpen}
        title={template?.name ? `Удалить шаблон «${template.name}»?` : 'Удалить шаблон?'}
        description="Это действие необратимо."
        isLoading={isLoading}
        onConfirm={onSubmit}
        onCancel={close}
      />
    ),
  };
}

export default useDeleteTemplateModal;
